"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconForward = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "10 6.66666667 10 3.33333333 16.6666667 10 10 16.6666667 10 13.3333333 3.33333333 13.3333333 3.33333333 6.66666667"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconForward')(IconForward);